<template>
  <div class="yinsi-box">
  	<div class="title">【星图慧联】隐私政策</div>
    <div class="haveTime">
      <p><b>更新日期：2026年04月09日</b></p>
      <p><b>生效日期：2026年04月16日</b></p>
    </div>
    <div class="setion" ref="yinsi">
      <p>欢迎您使用由河南威果智能科技有限公司（以下简称“<b>我们</b>”）为您提供的星图慧联服务（包括（1）PC端，涉及<b>智慧星图网站</b>（xt.xiangyuniot.com）、<b>威果安消网站</b>（jx.xiangyuniot.cn）；（2）移动端，涉及<b>智慧星图移动端</b>（通过微信服务号“智慧星图物联网平台”进入智慧星图网站）、<b>“星图慧联”微信小程序</b>，以下简称<b>“本产品”</b>）。我们通过本《【星图慧联】隐私政策》（以下简称“<b>本隐私政策”</b>）向您说明，您在使用本产品时我们收集、使用、存储和共享您的个人信息情况，以及您所享有的相关权利等事宜。本隐私政策与您使用我们的产品及/或服务息息相关。您在使用本产品时除应遵守本隐私政策，还应遵守本产品界面所展示的用户协议等适用于本产品的协议及规则以及您与我们之间的其他协议文件的约定。</p>
      <p>对于本隐私政策中与您的权益可能存在重大关系的条款，我们已采用<b>粗体</b>标识进行标注。对于敏感个人信息，我们已采用<b class="underline">粗体下划线</b>标识进行标注。</p>
      <p><b>在使用我们本产品前，请您务必审慎阅读并确认您已经充分理解本隐私政策所写明的内容。请特别注意以粗体标识的条款。您充分理解并同意，当您在本产品注册，并点击同意时，代表您在知情和同意的情况下，认可我们按照本隐私政策处理您的相关信息。如果您不同意本隐私政策内容，应立即停止使用本产品。</b></p>
      <p>本隐私政策仅适用于我们提供的本产品，不适用于第三方通过本产品向您提供的其他产品或服务，当您通过本产品链接到其他网站、客户端或移动应用时，我们无法控制该等第三方收集或获取您的信息。您应仔细阅读并了解第三方产品与/或服务或网站对于用户个人信息保护的相关条款，您知悉并同意，我们不为第三方的个人信息保护负责。</p>
      <p>如您有任何疑问、意见或建议，请通过以下联系方式与我们联系：</p>
      <p><span style="background-color: yellow;">注册地址：【河南省郑州市高新技术产业开发区梧桐街32号5号楼6B层】</span></p>
      <p><span style="background-color: yellow;">电话号码：【67169566】</span></p>
      <h2>本隐私政策将帮助您了解以下内容：</h2>
      <p>一、我们如何收集和使用您的个人信息</p>
      <p>二、我们如何使用Cookie和同类技术</p>
      <p>三、我们如何存储您的个人信息</p>
      <p>四、我们如何共享、委托处理、转让和公开披露您的个人信息</p>
      <p>五、我们如何保护您的个人信息</p>
      <p>六、您的个人信息权利</p>
      <p>七、我们如何处理未成年人的个人信息</p>
      <p>八、本隐私政策如何更新</p>
      <p>九、如何联系我们</p>

      <h2>一、我们如何收集和使用您的个人信息</h2>
      <p>在向您提供本产品的相关服务或功能中，我们可能在取得您的单独同意的前提下处理您的相关<b class="underline">敏感个人信息</b>。我们会采取必要的安全措施保障您的敏感个人信息安全，保护您的合法权益不受侵犯。</p>
      <p>我们提供的业务功能需要依赖部分信息才得以运行。您选择使用该项业务功能，则需要向我们提供或允许我们收集必要信息，对于我们提供特定服务时所必需的个人信息，若您不同意提供，则您无法使用相应服务。此外，为了优化为您提供的产品和服务功能，或向您提供某些增值服务，我们可能进一步向您收集特定个人信息，若您不同意提供，则无法使用该等优化或增值功能，但不影响其他基本服务或功能的使用。</p>
      <p>涉及收集、使用您的个人信息的具体功能场景如下：</p>
      <p>1.用户注册登录和用户信息管理</p>
      <p>微信小程序端：您可以通过微信小程序注册登录，我们会申请获取并验证您的【手机号】。登录后，您可以在“我的”界面修改头像，选择使用【微信头像】或者授权我们相册、相机权限，用于拍摄、上传您的头像。</p>

      <p>智慧星图移动端：您可以输入【账号、密码】登录，若选择使用微信账号登录，您需要绑定【手机号】。登录后，您可以修改您的个人资料【昵称、邮箱、手机号】，修改密码。</p>
      <p>智慧星图网站：您可以输入【用户名、密码】以登录网站。</p>
      <p>威果安消网站：您可以输入【用户名、密码】以登录网站。登录后，您可以修改个人资料，包括【姓名、邮箱、手机号、备注】。</p>
      <p>2.设备管理</p>
      <p>微信小程序端：您可以通过3种方式添加智能设备：授权相册、相机权限，扫描国际移动设备识别码（IMEI）以实现普通安装；授权访问蓝牙以实现蓝牙配网；输入家庭路由器信息（SSID、路由器密码）以实现WIFI配网。若您授权位置权限，我们可基于【<b class="underline">精准位置信息</b>】向您展示当地天气情况、湿度。</p>
      <p>智慧星图移动端：在安装设备时，您可以直接输入或授权相机、相册权限，用于扫码获取设备编号。您还需输入【安装位置、所在地址、安装区域、消防场所、安装人姓名、推送电话】，授权相机、相册权限拍摄、上传现场照片。在拆卸设备时，您可以输入设备编号、设备名称，或授权相机、相册权限扫码查询设备。您可以查看【设备IMEI、安装位置、安装区域、负责人信息、安装人信息】，授权相机、相册权限拍摄、上传现场照片。另外，您还能授权相机权限，实现扫码出库、解除出库。</p>
      <p>智慧星图网站：在“设备总览”中，您可查询、浏览设备信息，涉及【设备IMEI、设备定位、安装经纬度、负责人姓名及电话、安装人员姓名及电话、使用人姓名及电话】，添加现场照片。在具体设备管理时，您可查询前述设备信息、设备数据、报警记录、故障记录、安装记录。特别的，对于“睡眠雷达”，您可以查看睡眠报告，涉及【睡眠时间、上下床时间、平均呼吸、平均心率、呼吸暂停次数】。对于“工商业报警器”“复合烟感”“复合网关”设备，您可以查看年检信息，涉及【设备IMEI、年检负责人姓名及电话】。</p>
      <p>威果安消网站：您可以添加设备并编辑设备信息，涉及设备的【安装区域、安装位置、所在地理位置】。对于设备，您可以设置其推送号码，涉及【姓名、手机号码】；分配相关人员负责区域，涉及【负责人姓名】；查询【设备监控】。</p>
      <p>3.报警管理</p>
      <p>微信小程序端：您可以输入【设备IMEI】，以便搜索、处理报警事件。在“我的”界面，您可以添加【手机号】，作为报警接收电话。在“报警列表”，您可以输入【IMEI】搜索报警情况，您还能查看【安装位置、报警内容】。您还能授权提供您的【微信头像和微信昵称】以便进行消息订阅。</p>
      <p>智慧星图移动端：您可以输入【设备IMEI】，以便搜索、处理报警事件。在“我的”界面，处理报警事件时，您需要输入【处理类型、处理描述】，授权相机、相册权限拍摄、上传处理图片。您还可以授权位置权限，提供【<b class="underline">精准位置信息</b>】，用于查询去往事件现场的导航路线。</p>
      <p>智慧星图网站：您可以查看报警设备和已拆除设备的【设备IMEI、使用人、安装位置】，处理报警事件时您需要输入【处理类型、处理描述】，上传处理图片。您还能查看故障历史、异常设备、报修记录，涉及【设备IMEI、安装信息】。对于巡检事项，您可以输入【部门名称、负责人姓名、巡检点的详细位置、巡检人姓名】。</p>
      <p>威果安消网站：对报警、故障和隐患，您可以输入您的【处理意见】。</p>
      <p>4.意见反馈</p>
      <p>微信小程序端：您可以在“意见反馈”界面输入【标题、内容】，授权相机、相册权限拍摄、上传照片。</p>
      <p>智慧星图移动端：您可以点击“问题反馈”输入您想要反馈的内容，或者在“意见反馈”界面输入【标题、内容】，授权相机、相册权限拍摄、上传照片。</p>
      <p>智慧星图网站：您可以在“意见反馈”界面输入【反馈标题、详细内容】，插入图片。</p>
      <p><b>请您注意，为实现本项功能之目的，您所提供的信息均无需包含您或第三人的任何个人信息，我们亦建议及特此提请您注意不要在前述信息中提供包含您或第三人的个人信息。</b>提示您注意，您应对您所提供信息中包含的数据的来源及内容负责，我们提示您谨慎判断数据来源及内容的合法性，并保证您有权将前述数据提供给我们进行处理，不存在违法违规、侵权或违反与第三方合同约定的情形，因您提供数据内容及您的数据处理行为违反法律法规、部门规章或国家政策而造成的全部结果及责任均由您自行承担。</p>
      <p>5.系统管理</p>
      <p>智慧星图网站：您可以查看日志列表，涉及【操作人姓名及IP地址】。进行子租户管理时，您可以输入【租户昵称、登录名、密码、联系电话、邮箱、系统区域、租户描述】。进行资费管理时，您可以选择不同的运营商、套餐及卡数量，并上传含有ICCID和IMEI的文件进行购买，您可以选择使用微信或支付宝进行支付，并可以在“资费记录”中进行查看您的购买记录，用于购买资费。进行组织管理时，您需要输入【用户昵称、用户手机号、组织机构、用户邮箱】以添加用户。您还可以在系统设置选择打开或关闭系统通知通道，上传系统LOGO图片。</p>
      <p>威果安消网站：您可以添加、修改用户信息【姓名、邮箱、电话、登录名、归属机构、用户角色】；新增机构，输入【机构邮箱、电话、传真、邮政编码、联系地址、备注】。您还能输入平台【服务热线】，上传【平台LOGO图片】。</p>
      <p>6.安全保障</p>
      <p>为了保障本产品的正常运行及运营安全，保护您或其他用户或公众的合法利益免受损失，我们需要收集和使用【IP地址】。请注意，单独的日志信息是无法识别特定自然人的身份，除非将这类非个人信息与其他信息结合用于识别特定自然人身份。在这种情况下，结合使用期间的非个人信息将被视为个人信息，我们会将该类信息进行匿名化和去标识化处理，除非取得您的授权或法律法规另有规定。</p>
      <p>（一）第三方SDK</p>
      <p>我们提供部分功能与/或服务时需要使用第三方的软件开发工具包（SDK）和应用程序接口（API）技术（合称<b>“第三方SDK”</b>），这些第三方SDK可能会收集和处理您的部分个人信息或设备权限。我们将审慎评估合作方使用数据的目的，对这些合作方的安全保障能力进行综合评估，对合作方获取信息的第三方SDK进行严格的安全监测，以保护数据安全。了解更多有关第三方SDK处理个人信息的目的、方式及范围等信息，请查看本隐私政策附件<a href="#a1">《第三方SDK清单》</a>。</p>
      <p>（二）系统权限调用</p>
      <p>为提升服务体验或向您提供必要的服务，本产品的个别功能/服务可能需要使用您的系统权限，本产品可能会调用您的一些设备权限，我们调用权限的场景目的，以及调用权限前向您询问的情况，请查看本隐私政策附件<a href="#a2">《系统权限调用清单》</a>。您可以在设备的设置功能中选择关闭部分或全部权限，从而拒绝本产品调用您的系统权限。使用Android/iOS系统的不同设备中，权限显示方式及关闭方式可能有所相同，具体请联系设备及系统开发方。</p>
      <p>请您注意，您开启任一权限即代表您授权我们可以收集和使用相关个人信息来为您提供对应服务，您一旦关闭任一权限即代表您取消了授权，我们将不再基于对应权限继续收集和使用相关个人信息，也无法继续为您提供该权限所对应的服务。您关闭权限的决定不会影响此前基于您的授权所进行的个人信息收集及使用。<b class="underline">请您注意，为提供本产品服务之目的，我们通过调用您系统权限所收集的信息均无需包含您或第三人的任何个人信息，我们亦建议及特此提请您注意不要在前述信息中提供包含您或第三人的个人信息。</b></p>
      <p>（一）征得授权同意及告知的例外</p>
      <b>
        <p>1.根据相关法律法规及国家标准，以下情形中，我们可能会收集、使用您的相关个人信息无需征求您的授权同意：</p>
        <p>(1)为订立、履行个人作为一方当事人的合同所必需，或者按照依法制定的劳动规章制度和依法签订的集体合同实施人力资源管理所必需；</p>
        <p>(2)为履行法定职责或者法定义务所必需；</p>
        <p>(3)为应对突发公共卫生事件，或者紧急情况下为保护自然人的生命健康和财产安全所必需；</p>
        <p>(4)为公共利益实施新闻报道、舆论监督等行为，在合理的范围内处理个人信息；</p>
        <p>(5)依照《个人信息保护法》或其他适用法律法规规定在合理的范围内处理个人自行公开或者其他已经合法公开的个人信息；</p>
        <p>(6)法律、行政法规规定的其他情形。</p>
        <p>2.在以下情形下，我们可能不会向您告知我们处理您的个人信息：</p>
        <p>(1)紧急情况下为保护自然人的生命健康和财产安全无法及时向您告知的（但在紧急情况消除后我们会及时向您告知）；</p>
        <p>(2)有法律、行政法规规定应当保密或者不需要告知您的。</p>
      </b>
      <h2>二、我们如何使用Cookie的同类技术</h2>
      <p>（一）在您使用本产品PC端时，我们可能会使用Cookie的同类技术收集您的一些个人信息，包括：【您的访问习惯、您的浏览信息、您的登录信息】，Cookie和同类技术收集该类信息是为了您使用我们的产品与/或服务的必要、简化您重复操作的步骤（如注册、登录）、便于您查看使用历史、向您提供更切合您个人需要的服务内容和您可能更感兴趣的内容、保护您的信息和账号安全性、提升我们的产品和服务等。</p>
      <p>如果您拒绝我们使用Cookie及同类技术收集和使用您的相关个人信息，您可在浏览器具备该功能的前提下，通过您的浏览器的设置以管理、（部分/全部）拒绝Cookie与/或同类技术；或删除已经储存在您的计算机、移动设备或其他装置内的Cookie与/或同类技术，从而使我们无法全部或部分追踪您的个人信息。您如需详细了解如何更改浏览器设置，请具体查看您使用的浏览器的相关设置页面。</p>
      <p><b>您理解并知悉：我们的某些产品与/或服务依赖于Cookie的同类技术才可得到实现，如您拒绝使用或删除Cookie的同类技术，您可能无法使用依赖于该等Cookie同类技术的服务或相应功能。</b></p>
      <p>（二）在您使用本产品微信小程序时，我们可能会使用Cookie的同类技术收集您的一些个人信息，包括本地存储（例如利用小程序进行数据缓存）、数据库和服务日志。</p>
      <h2>三、我们如何存储您的个人信息</h2>
      <p>（一）信息存储的方式和期限</p>
      <p>我们会通过安全的方式存储您的信息。一般情况下，我们只会在为实现服务目的所必需的时间内或法律法规规定的条件下存储您的个人信息。前述期限届满后，我们将对您的个人信息做删除或匿名化处理。我们判断个人信息的存储期限主要参考以下标准并<b>以其中较长者为准：</b></p>
      <p>1.完成您同意使用的业务功能；</p>
      <p>2.保证我们为您提供服务的安全和质量；</p>
      <p>3.您同意的更长的存储期间；</p>
      <p>4.是否存在存储期限的其他规定。</p>
      <p>（二）信息存储的地域</p>
      <p>我们会按照法律法规规定，将境内收集的用户个人信息存储于中华人民共和国境内。</p>
      <p>（三）产品或服务停止运营时的通知</p>
      <p>当我们的产品或服务发生停止运营的情况时，我们将根据相关法律法规规定或双方约定进行公告通知，并停止对您的个人信息进行收集，同时删除已收集到的您的个人信息或对其匿名化处理。</p>
      <h2>四、我们如何共享、委托处理、转让和公开披露您的个人信息</h2>
      <p>（一）共享</p>
      <p>对于您的个人信息，我们仅在本隐私政策所述目的和范围内或根据法律法规的要求收集和使用，并严格保密。非经过法定程序或您本人事先单独同意，我们不会与任何公司、组织和个人共享您的个人信息。除以下情况外，我们不会与任何公司、组织和个人共享您的个人信息：</p>
      <p>1.事先获得您的明确授权或同意或基于您的要求。</p>
      <p>2.与我们的业务合作伙伴进行必要的信息共享，我们仅会出于合法、正当、必要、特定、明确的目的，与我们的合作伙伴共享您的个人信息，并且只会共享提供服务所必要的个人信息。同时，对我们与之共享个人信息的公司、组织和个人，我们会与之签署严格的保密协议，要求他们按照我们的说明、本隐私政策及其他任何相关的保密和安全措施来处理个人信息。如果您拒绝我们的合作方在提供服务时收集为提供服务所必需的个人信息，将可能导致您无法使用本产品来享用该合作方提供的服务。我们向业务合作伙伴共享个人信息的情况请见本隐私政策附件<a href="#a3">《第三方共享信息清单》</a>。</p>
      <p>3.履行法定义务所必需：根据适用的法律法规、诉讼、争议解决的必要，或按行政、司法机关依法提出的要求，以及其他法定义务履行所必需而共享您的个人信息。</p>
      <p>4.在法律要求或允许的范围内，为了保护本公司及其用户或社会公众的利益、财产或安全免遭损害而有必要提供。</p>
      <p>（二）委托处理</p>
      <p>我们提供的产品和/或服务中的某些具体的模块或功能由外部供应商提供。对我们委托处理个人信息的公司、组织和个人，我们会与其签署严格的保密协定，要求他们按照我们的要求、本隐私政策以及其他任何相关的保密和安全措施来处理个人信息。</p>
      <p>（三）转让</p>
      <p>我们不会将您的个人信息转让给任何公司、组织和个人，但以下情形除外：</p>
      <p>1.获得您的明示授权或同意或基于您的要求；</p>
      <p>2.适用的法律法规、法律程序要求或强制性的政府要求或司法裁定必须提供的；</p>
      <p>3.为了国家安全、国防安全、公共安全、公共卫生、重大公共利益而需要提供的；</p>
      <p>4.为了维护您或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；</p>
      <p>5.在涉及合并、分立、解散、收购或被宣告破产时。如涉及到个人信息转让，我们会向您告知个人信息接收方的名称和联系方式。我们会要求新的持有您个人信息的公司、组织继续受此个人信息保护政策的约束，否则我们将要求该公司、组织重新向您征求授权同意。</p>
      <p>6.您自行向社会公众公开的个人信息；</p>
      <p>7.从合法公开披露的信息中收集个人信息的，如通过合法的新闻报道、政府信息公开等渠道。</p>
      <p>（四）公开披露</p>
      <p>原则上我们不会向社会或不特定人群发布您的个人信息，但以下情况除外：</p>
      <p>1.获得您的明示授权或同意或基于您的要求；</p>
      <p>2.根据适用的法律法规、法律程序要求或强制性的政府要求或司法裁定必须提供的；</p>
      <p>3.为了国家安全、国防安全、公共安全、公共卫生、重大公共利益而需要提供的；</p>
      <p>4.为了维护您或其他个人的生命、财产等重大合法权益的。</p>
      <p>（五）依法豁免征得同意共享、转让、公开披露的个人信息</p>
      <p>请您理解，在下列情形中，根据法律法规及国家标准，我们会公开披露您的个人信息无需征得您的授权同意：</p>
      <p>1.与国家安全、国防安全直接相关的；</p>
      <p>2.与公共安全、公共卫生、重大公共利益直接相关的；</p>
      <p>3.与犯罪侦查、起诉、审判和判决执行直接相关的；</p>
      <p>4.出于维护您或其他个人的生命、财产重大合法权益但又很难得到您的同意的；</p>
      <p>5.您自行向社会公众公开的个人信息；</p>
      <p>6.从合法公开披露的信息中收集个人信息的，包括合法的新闻报道、政府信息公开渠道。</p>
      <h2>五、我们如何保护您的个人信息</h2>
      <p>（一）安全保护措施</p>
      <p>我们会采用符合业界标准的安全防护措施，包括建立合理的制度规范、安全技术来防止您的个人信息遭到未经授权的访问使用、修改，避免数据的损坏或丢失。我们采取了加密技术对您的个人信息进行加密保存，并通过隔离技术进行隔离。在个人信息使用时，我们会采用多种数据脱敏技术增强信息在使用中的安全性。我们还会采用严格的数据访问权限控制等措施保护个人信息，避免数据被违规使用。</p>
      <p>我们建立了保障个人信息安全专门的管理制度、流程和组织。例如，我们严格限制访问信息的人员范围，要求他们遵守保密义务并进行审计，违反义务的人员会根据规定进行处罚。我们也会审查该管理制度、流程和组织，以防未经授权的人员擅自访问、使用或披露用户信息。</p>
      <p>我们仅允许有必要知晓这些信息的员工、合作伙伴访问您的个人信息，并为此设置了严格的访问权限控制和监控机制。我们同时要求可能接触到您的个人信息的所有人员履行相应的保密义务。如果未能履行这些义务，可能会被追究法律责任或被中止与我们的合作关系。</p>
      <p><b>尽管已经采取了上述合理有效措施，并已经遵守了相关法律规定要求的标准，但请您理解，您提供给我们信息的安全性，仍受到例如技术的局限性以及可能存在的各种恶意手段的限制。您知悉并理解，您接入我们的服务所用的系统和通讯网络，有可能因我们可控范围外的因素而出现问题。因此，我们强烈建议您采取积极措施保护用户个人信息的安全，包括但不限于使用复杂密码、定期修改密码、不将自己的账号密码等信息透露给他人。</b></p>
      <p>（二）安全事件处置措施</p>
      <p>若不幸发生个人信息泄露等安全事件，我们会启动应急预案，阻止安全事件扩大，消除安全隐患，并按照规定向有关主管部门报告。安全事件发生后，如该事件对您的个人、组织合法权益造成危害的，我们会及时以公告、推送通知或邮件等形式告知您安全事件的基本情况、危害后果、我们即将或已经采取的处置措施和补救措施，以及我们对您的应对建议。如果难以实现逐一告知，我们将通过公告等方式发布警示。</p>
      <p><b>我们谨此特别提醒您，本隐私政策提供的用户个人信息保护措施仅适用于本产品相关服务。一旦您离开本产品，浏览或使用其他网站、产品、服务及内容资源，我们即没有能力及义务保护您在本产品之外的软件、网站提交的任何信息，无论您登录、浏览或使用上述软件、网站是否基于本产品的链接或引导。</b></p>
      <h2>六、您的个人信息权利</h2>
      <p>（一）查阅和复制您的个人信息</p>
      <p>您有权访问您的个人信息，法律法规规定的例外情况除外。您可通过本隐私政策载明的联系方式联系我们查阅和复制您的个人信息。</p>
      <p>（二）更正、补充您的个人信息</p>
      <p>当您发现我们处理的关于您的个人信息不准确、不完整或有错误时，您有权要求我们作出更正、补充。您可以通过本隐私政策载明的联系方式联系我们提出更正申请。</p>
      <p>（三）删除您的个人信息</p>
      <p>在以下情形中，您可以通过本隐私政策载明的联系方式向我们提出删除个人信息的请求：</p>
      <p>1.我们处理您个人信息的目的已实现、无法实现或者为实现处理目的不再必要；</p>
      <p>2.我们停止提供产品或者服务，或者保存期限已届满；</p>
      <p>3.您撤回同意；</p>
      <p>4.我们违反法律、行政法规或者违反约定处理个人信息；</p>
      <p>5.法律、行政法规规定的其他情形。</p>
      <p>当您从我们的服务中删除信息后，我们可能不会立即在备份系统中删除相应的信息，但会在备份更新时删除这些信息或实现匿名化。若我们决定响应您的删除请求，我们还将同时通知从我们获得您的个人信息的实体，要求其及时删除，除非法律法规另有规定，或这些实体获得您的独立授权。若法律、行政法规规定的保存期限未届满，或者删除个人信息从技术上难以实现的，我们将停止除存储和采取必要的安全保护措施之外的处理。</p>
      <p>（四）改变您授权同意的范围或撤回授权同意</p>
      <p>请您理解，每个业务功能需要一些基本个人信息才能得以完成。对于最基本之外的个人信息的收集和使用，您可以随时给予或撤回您的授权同意。对于本公司产品及/或服务的撤回授权，您可以通过本隐私政策载明的联系方式提出撤回授权申请。您也可以通过注销账号的方式，撤回我们继续收集您个人信息的全部授权。</p>
      <p>撤回授权后，您可能无法使用该授权对应产品功能，但不影响其他功能的使用。您撤回授权不影响撤回前基于您的授权已经进行的个人信息处理活动的效力。</p>
      <p>当您撤回授权或同意后，我们将不再处理相应的个人信息。但您撤回授权或同意的决定，不会影响此前基于您的授权而开展的个人信息处理活动。</p>
      <p>（五）注销账户</p>
      <p>您可以通过本隐私政策载明的联系方式向我们申请注销账号。在注销账号之后，我们将停止为您提供本公司产品及/或服务，并依据您的要求，删除或匿名化处理您的个人信息，但法律法规规定的保存期限未届满，或者删除个人信息从技术上难以实现的，我们将停止除存储和采取必要的安全保护措施之外的处理。</p>
      <p>（六）获取个人信息副本</p>
      <p>您有权获得您的个人信息副本，您可以通过本隐私政策载明的联系方式向我们申请获取个人信息副本。</p>
      <p>（七）知情权、决定权、限制权和拒绝权以及其他权利</p>
      <p>您可以通过本隐私政策载明的联系方式行使您的知情权、决定权、限制权和拒绝权以及法律法规赋予您的其他个人信息保护相关的权利。在符合国家网信部门规定条件的情况下，我们将配合您将个人信息转移至您指定的个人信息处理者的请求提供转移路径。法律、行政法规另有规定的除外。在特殊情况下（例如，用户身故），用户的近亲属有权依法查阅、更正和删除死者的个人信息，但该用户生前另有书面安排并及时通知到我们的除外。</p>
      <p>此外，您有权要求我们对本隐私政策及相关个人信息处理活动的处理规则进行解释说明。</p>
      <p>（八）响应您的上述请求</p>
      <p>如果您认为我们存在任何违反法律法规或本隐私政策规定的情形，您均可以通过本隐私政策载明的联系方式与我们联系。</p>
      <p>为保障您的信息安全，我们可能需要您提供书面请求，或以其他方式证明您的身份。我们将在收到您反馈并验证您的身份后15个工作日内答复您的请求。</p>
      <p>对于您合理的请求，我们原则上不收取费用。对于那些无端重复、需要过多技术手段（例如，需要开发新系统或从根本上改变现行惯例）、给他人合法权益带来风险或者非常不切实际的请求，我们可能会予以拒绝。</p>
      <p>在以下情形中，按照法律法规要求，我们将无法响应您的请求：</p>
      <p>1.与我们履行法律法规规定的义务相关的；</p>
      <p>2.与国家安全、国防安全直接相关的；</p>
      <p>3.与公共安全、公共卫生、重大公共利益直接相关的；</p>
      <p>4.与刑事侦查、起诉、审判和执行判决等直接相关的；</p>
      <p>5.我们有充分证据表明您存在主观恶意或滥用权利的；</p>
      <p>6.出于维护您或其他个人的生命、财产等重大合法权益但又很难得到您授权同意的；</p>
      <p>7.响应您的请求将导致您或其他个人、组织的合法权益受到严重损害的；</p>
      <p>8.涉及商业秘密的。</p>
      <h2>七、我们如何处理未成年人的个人信息</h2>
      <p>本场景下我们不处理未成年人个人信息，若您是未成年人，请您或您的监护人根据本政策联系方式通知我们。我们将根据法律法规的要求及时删除您的个人信息或进行匿名化处理。</p>
      <h2>八、本隐私政策如何更新</h2>
      <p>为了给您提供更好的服务，我们可能会根据产品或服务的更新情况及法律法规的相关要求适时修改本隐私政策的条款，该等修改构成本隐私政策的一部分。<b>如该等更新造成您在本隐私政策下权利的实质减少或重大变更，我们将在本隐私政策生效前通过【弹窗提示】或其他方式来通知您</b>，您如果不同意该等变更，可以选择停止使用本产品；如您仍然继续使用本产品的，即表示您已充分阅读、理解并同意受经修订的本隐私政策的约束。未经您的知情和同意（如适用同意作为合法性基础），我们不会削减您按照本隐私政策所享有的权利。</p>
      <p>本隐私政策所指的重大、实质性变更包括但不限于：</p>
      <p>1.我们的产品及/或服务模式发生重大变化。如处理个人信息的目的、处理个人信息的类型、个人信息的使用方式等；</p>
      <p>2.我们在控制权等方面发生重大变化。如并购重组等引起的所有者变更等；</p>
      <p>3.个人信息共享、转让或公开披露的主要对象发生变化；</p>
      <p>4.您参与个人信息处理方面的权利及其行使方式发生重大变化；</p>
      <p>5.我们负责处理个人信息安全的责任部门、联络方式及投诉渠道发生变化时；</p>
      <p>6.个人信息安全影响评估报告表明存在高风险时。</p>
      <p>我们可能在必需时（例如当我们由于系统维护而暂停某一项服务时）发出与服务有关的公告。您可能无法取消这些与服务有关、性质不属于推广的公告。</p>
      <h2>九、如何联系我们</h2>
      <p>如您有关于本隐私政策的任何疑问、问题或建议请通过以下联系方式联系我们。一般情况下，我们将在收到您的问题、意见或建议，并验证您的用户身份后的15个工作日内予以回复： </p>
      <p><span style="background-color: yellow;">注册地址：【河南省郑州市高新技术产业开发区梧桐街32号5号楼6B层】</span></p>
      <p><span style="background-color: yellow;">电话号码：【67169566】</span></p>
      <el-divider></el-divider>
      <h2>附件</h2>
      <h3>个人收集清单</h3>
      <br>
      <h4>微信小程序端：</h4>
      <el-table :data="tableData1" border style="width: 100%">
		    <el-table-column prop="t1" label="业务场景" />
		    <el-table-column prop="t2" label="信息类型" />
		    <el-table-column prop="t3" label="收集目的" />
		    <el-table-column prop="t4" label="收集方式" />
		  </el-table>
		  <br>
		  <h4>智慧星图移动端：</h4>
      <el-table :data="tableData2" border style="width: 100%">
		    <el-table-column prop="t1" label="业务场景" />
		    <el-table-column prop="t2" label="信息类型" />
		    <el-table-column prop="t3" label="收集目的" />
		    <el-table-column prop="t4" label="收集方式" />
		  </el-table>
		  <br>
		  <h4>智慧星图网站：</h4>
      <el-table :data="tableData3" border style="width: 100%">
		    <el-table-column prop="t1" label="业务场景" />
		    <el-table-column prop="t2" label="信息类型" />
		    <el-table-column prop="t3" label="收集目的" />
		    <el-table-column prop="t4" label="收集方式" />
		  </el-table>
		  <br>
		  <h4>威果安消网站：</h4>
      <el-table :data="tableData4" border style="width: 100%">
		    <el-table-column prop="t1" label="业务场景" />
		    <el-table-column prop="t2" label="信息类型" />
		    <el-table-column prop="t3" label="收集目的" />
		    <el-table-column prop="t4" label="收集方式" />
		  </el-table>
		  <br>
		  <h4>其他场景：</h4>
      <el-table :data="tableData5" border style="width: 100%">
		    <el-table-column prop="t1" label="业务场景" />
		    <el-table-column prop="t2" label="信息类型" />
		    <el-table-column prop="t3" label="收集目的" />
		    <el-table-column prop="t4" label="收集方式" />
		  </el-table>
		  <br />
		  <br />
		  <h3 id="a3">第三方共享信息清单</h3>
		  <br />
		  <p><b>一、第三方共享清单</b></p>
		  <p>无</p>
		  <p id="a1"><b>二、第三方SDK清单</b></p>
		  <p>为保障产品/服务稳定运行或实现相关功能，我们还可能会接入第三方SDK实现前述目的。我们在以下清单中列明接入的相关第三方SDK。你可以通过目录中提供的链接或者路径查看第三方的数据使用和保护规则。请注意，第三方SDK可能由于版本升级、策略调整等原因导致其个人信息处理类型发生变化，请以其公示的官方说明为准。</p>
		  <p><b>1、AiThinkerAirkissforWXMini</b></p>
		  <p>第三方主体：深圳市安信可科技有限公司</p>
		  <p>涉及的个人信息类型：路由器的名称/SSID和密码、设备的IP地址和MAC地址</p>
		  <p>使用目的：用于将您指定的智能硬件设备连接至本地Wi-Fi网络</p>
		  <p>使用场景：当您在设备安装时主动选择wifi配网方式为新的智能硬件设备进行网络配置时触发</p>
		  <p>收集方式：终端发起传输</p>
		  <p>隐私政策：<a href="https://aithinker-static.oss-cn-shenzhen.aliyuncs.com/officialwebsite/privacy.pdf" target="_blank">https://aithinker-static.oss-cn-shenzhen.aliyuncs.com/officialwebsite/privacy.pdf</a></p>
		  <p><b>2、高德地图SDK</b></p>
		  <p>第三方主体：高德软件有限公司</p>
		  <p>涉及的个人信息类型：<b class="underline"></b>精准位置信息</p>
		  <p>使用目的：</p>
		  <p>1）用于展示用户当地位置的实时天气信息</p>
		  <p>（2）用于展示用户安装设备时设备的位置，后续方便用户查看设备在地图中的分布情况</p>
		  <p>（3）用于导航前往事件发生地</p>
		  <p>使用场景：</p>
		  <p>（1）天气展示：当您需要在查看您当地天气情况时触发</p>
		  <p>（2）设备安装：当您需要查看设备在地图中的位置、分布情况时触发</p>
		  <p>（3）导航：当您需要导航前往事件发生地时触发</p>
		  <p>收集方式：后台接口传输</p>
		  <p>隐私政策：<a href="https://cache.amap.com/h5/h5/publish/238/index.html" target="_blank">https://cache.amap.com/h5/h5/publish/238/index.html</a> </p>
		  <br />
		  <br />
		  <h3 id="a2">系统权限调用清单</h3>
		  <br />
		  <h4>微信小程序端：</h4>
		  <table class="custom-table">
	      <thead>
	        <tr>
	          <th>设备权限</th>
	          <th>调用权限场景</th>
	          <th>调用权限目的</th>
	          <th>是否询问</th>
	          <th>可否关闭权限</th>
	        </tr>
	      </thead>
	      <tbody>
	        <tr>
	          <td>位置权限</td>
	          <td>展示天气信息</td>
	          <td>提供天气信息</td>
	          <td>首次适用相应功能时，弹窗提示</td>
	          <td>是</td>
	        </tr>
	        <tr>
	          <td rowspan="2">相册权限</td>
	          <td>意见反馈</td>
	          <td>上传照片、视频</td>
	          <td>首次适用相应功能时，弹窗提示</td>
	          <td>是</td>
	        </tr>
	        <tr>
	          <td>修改头像</td>
	          <td>上传照片</td>
	          <td>首次适用相应功能时，弹窗提示</td>
	          <td>是</td>
	        </tr>
	        <tr>
	          <td rowspan="3">摄像头权限</td>
	          <td>意见反馈</td>
	          <td>拍摄上传照片、视频</td>
	          <td>首次适用相应功能时，弹窗提示</td>
	          <td>是</td>
	        </tr>
	        <tr>
	          <td>修改头像</td>
	          <td>拍摄上传照片</td>
	          <td>首次适用相应功能时，弹窗提示</td>
	          <td>是</td>
	        </tr>
	        <tr>
	          <td>添加设备</td>
	          <td>扫码快速获取设备编码</td>
	          <td>首次适用相应功能时，弹窗提示</td>
	          <td>是</td>
	        </tr>
	        <tr>
	          <td rowspan="1">蓝牙权限</td>
	          <td>蓝牙配网的方式安装设备</td>
	          <td>蓝牙连接</td>
	          <td>首次适用相应功能时，弹窗提示</td>
	          <td>是</td>
	        </tr>
	      </tbody>
	    </table>
	    <br />
		  <h4>智慧星图移动端：</h4>
		  <table class="custom-table">
	      <thead>
	        <tr>
	          <th>设备权限</th>
	          <th>调用权限场景</th>
	          <th>调用权限目的</th>
	          <th>是否询问</th>
	          <th>可否关闭权限</th>
	        </tr>
	      </thead>
	      <tbody>
	        <tr>
	          <td rowspan="2">位置权限</td>
	          <td>用于在地图上展示具体位置</td>
	          <td>设备安装地图展示</td>
	          <td>首次适用相应功能时，弹窗提示</td>
	          <td>是</td>
	        </tr>
	        <tr>
	          <td>方便用户之后查看设备在地图中的分布情况。</td>
	          <td>查看设备分布</td>
	          <td>首次适用相应功能时，弹窗提示</td>
	          <td>是</td>
	        </tr>
	        <tr>
	          <td rowspan="3">相册权限</td>
	          <td>现场处理事件</td>
	          <td>上传照片、视频</td>
	          <td>首次适用相应功能时，弹窗提示</td>
	          <td>是</td>
	        </tr>
	        <tr>
	          <td>添加设备</td>
	          <td>扫码快速获取设备编码</td>
	          <td>首次适用相应功能时，弹窗提示</td>
	          <td>是</td>
	        </tr>
	        <tr>
	          <td>意见反馈</td>
	          <td>上传照片、视频</td>
	          <td>首次适用相应功能时，弹窗提示</td>
	          <td>是</td>
	        </tr>
	        <tr>
	          <td rowspan="3">摄像头权限</td>
	          <td>现场处理事件</td>
	          <td>拍摄上传照片、视频</td>
	          <td>首次适用相应功能时，弹窗提示</td>
	          <td>是</td>
	        </tr>
	        <tr>
	          <td>添加设备</td>
	          <td>扫码快速获取设备编码</td>
	          <td>首次适用相应功能时，弹窗提示</td>
	          <td>是</td>
	        </tr>
	        <tr>
	          <td>意见反馈</td>
	          <td>拍摄上传照片、视频</td>
	          <td>首次适用相应功能时，弹窗提示</td>
	          <td>是</td>
	        </tr>
	      </tbody>
	    </table>
    </div>
  </div>
</template>

<script>
import { textPassword } from '@/utils/validate'
export default {
	props: {
    showYinsi: {
      type: Boolean,
      default: false
    },
    isRead: {
      type: Boolean,
      default: true
    },
    isSetShow: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
    	tableData1: [
    		{ t1: '注册登录', t2: '手机号', t3: '用户登录', t4: '用户主动提供' },
    		{ t1: '修改头像', t2: '微信头像', t3: '拍摄、上传您的头像', t4: '用户主动提供' },
    		{ t1: '设备管理', t2: '输入家庭路由器信息（SSID、路由器密码）以实现WIFI配网', t3: '添加智能设备', t4: '用户主动提供' },
    		{ t1: '设备管理', t2: '精准位置信息', t3: '向用户展示当地天气情况、湿度', t4: '用户主动提供' },
    		{ t1: '报警管理', t2: '设备IMEI、安装位置、报警内容', t3: '以便用户搜索、处理报警事件', t4: '用户主动提供' },
    		{ t1: '报警管理', t2: '微信头像、微信昵称', t3: '以便订阅消息', t4: '用户主动提供' },
    		{ t1: '报警管理', t2: '手机号', t3: '报警接收电话', t4: '用户主动提供' },
    		{ t1: '意见反馈', t2: '标题、内容', t3: '意见反馈', t4: '用户主动提供' },
    	],
    	tableData2: [
    		{ t1: '登录', t2: '账号、密码或使用微信账号登录需要绑定手机号', t3: '用户登录', t4: '用户主动提供' },
    		{ t1: '修改个人资料', t2: '昵称、邮箱、手机号、密码', t3: '修改个人资料', t4: '用户主动提供' },
    		{ t1: '设备管理', t2: '安装位置、所在地址、安装区域、消防场所、安装人姓名、推送电话', t3: '安装设备', t4: '用户主动提供' },
    		{ t1: '报警管理', t2: '处理类型、处理描述', t3: '处理报警事件', t4: '用户主动提供' },
    		{ t1: '意见反馈', t2: '标题、内容', t3: '意见反馈', t4: '用户主动提供' },
    	],
    	tableData3: [
    		{ t1: '登录', t2: '用户名、密码', t3: '用户登录', t4: '用户主动提供' },
    		{ t1: '报警管理', t2: '处理类型、处理描述', t3: '处理报警事件', t4: '用户主动提供' },
    		{ t1: '报警管理', t2: '部门名称、负责人姓名、巡检点的详细位置、巡检人姓名', t3: '巡检事项', t4: '用户主动提供' },
    		{ t1: '意见反馈', t2: '反馈标题、详细内容，图片', t3: '意见反馈', t4: '用户主动提供' },
    		{ t1: '系统管理', t2: '租户昵称、登录名、密码、联系电话、邮箱、系统区域、租户描述', t3: '子租户管理', t4: '用户主动提供' },
    		{ t1: '系统管理', t2: '用户昵称、用户手机号、组织机构、用户邮箱，上传系统LOGO图片', t3: '组织管理', t4: '用户主动提供' },
    	],
    	tableData4: [
    		{ t1: '登录', t2: '用户名、密码', t3: '用户登录', t4: '用户主动提供' },
    		{ t1: '修改个人资料', t2: '姓名、邮箱、手机号、备注', t3: '修改个人资料', t4: '用户主动提供' },
    		{ t1: '设备管理', t2: '设备的安装区域、安装位置、所在地理位置', t3: '添加设备并编辑设备信息', t4: '用户主动提供' },
    		{ t1: '设备管理', t2: '姓名、手机号码', t3: '设置推送号码', t4: '用户主动提供' },
    		{ t1: '设备管理', t2: '负责人姓名', t3: '分配相关人员负责区域', t4: '用户主动提供' },
    		{ t1: '报警管理', t2: '处理意见', t3: '报警、故障和隐患', t4: '用户主动提供' },
    		{ t1: '系统管理', t2: '姓名、邮箱、电话、登录名、归属机构、用户角色', t3: '添加、修改用户信息', t4: '用户主动提供' },
    		{ t1: '系统管理', t2: '机构邮箱、电话、传真、邮政编码、联系地址、备注、服务热线、平台LOGO图片', t3: '新增机构', t4: '用户主动提供' },
    	],
    	tableData5: [
    		{ t1: '安全保障', t2: 'IP地址', t3: '保障本产品的正常运行及运营安全', t4: '系统自动收集' },
    	],
    	tableData6: [
    		{ t1: '', t2: '', t3: '', t4: '首次适用相应功能时，弹窗提示' , t5: '是' },
    	],
    	tableData7: [
    		{ t1: '', t2: '', t3: '', t4: '首次适用相应功能时，弹窗提示' , t5: '是' },
    	]
    }
  },
  created() {
  },
  mounted() {
  },
  methods: {
    handleAgreed () {
    	this.$emit('handleAgreed')
    },
    handleYinsiClosed () {
    	this.$emit('update:showYinsi', false)
    },
  },
};

</script>

<style lang="scss" scoped>
.yinsi-box {
  padding: 50px;
  background: #fff;
  font-size: 14px;
  height: 100%;
  width: 100%;
  max-width: 1400px;
  box-sizing: border-box;
  overflow-y: auto;
  margin: 0 auto;
  .title {
  	font-size: 30px;
  	text-align: center;
  	font-weight: bold;
  }
  .haveTime {
    text-align: right;
    margin:10px;
  }
  .underline {
    text-decoration: underline;
  }
  .setion {
    h2 {
      font-size: 14px;
      margin: 15px 0 8px;
    }
    h4 {
    	line-height: 30px;
    }
    p {
      line-height: 20px;
      text-indent: 28px;
    }
    .mation {
      font-weight: bold;
      &.first {
        margin-top: 10px;
      }
    }
  }
  .dialog-footer {
    margin-top: 20px;
    text-align: right;
  }
  .custom-table {
	  width: 100%;
	  border-collapse: collapse;
	  text-align: center;
	  font-size: 14px;
	}

	.custom-table th,
	.custom-table td {
	  border: 1px solid #e6e6e6;
	  padding: 12px 8px;
	  vertical-align: middle;
	}

	.custom-table th {
	  background-color: #f7f8fa;
	  font-weight: 500;
	}
}
</style>
<style lang="scss">
.yinsi-box {
  .el-form-item {
    margin-bottom: 25px;
    .el-form-item__label {
      display: none;
    }
    .el-form-item__content {
      // margin-left: 0;
      text-align: left;
      position: relative;
      .el-input {
        .el-input__inner {
          font-size: 14px;
          height: 42px;
          line-height: 42px;
          border-radius: 4px;
          border: 1px solid rgba(0, 75, 112, 0.5);
          color: #fff;
          padding-left: 20px;
          // background: rgba(0, 75, 112, 0.5);
          background: rgba(29, 185, 253, .4);
          &::placeholder{
            font-size: 14px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #01ABFF;
            opacity: 0.6;
          }
        }
        .el-input__prefix {
          left: 14px;
          .inputIcon {
            display: none;
            line-height: 0;
            margin-top: 10px;
            font-size: 0;
            width: 24px;
            height: 24px;
            img {
              width: 100%;
            }
          }
        }
      }
      .codeInput {
        width: 60%;
      }
      .el-checkbox {
        .el-checkbox__input {
          .el-checkbox__inner {
            width: 16px;
            height: 16px;
            border-radius: 4px;
            &::after {
              width: 5px;
              height: 10px;
              left: 6px;
              border-color: #3464e1;
            }
          }
        }
        .is-checked {
          .el-checkbox__inner {
            background: #fff;
            border-color: #fff;
          }
        }
        .el-checkbox__label {
          font-size: 14px;
        }
      }
      .el-button {
        width: 120px;
        height: 42px;
        background: rgba(74, 120, 187, 1);
        border-radius: 8px;
        font-size: 14px;
        color: #fff;
        border:none;
      }
      .forget {
        font-size: 13px;
        position: absolute;
        bottom: 17px;
        right: 0;
        color: #01ABFF;
        cursor: pointer;
      }
    }
  }
  .el-table {
  	th.el-table__cell{
			background: #f7f8fa!important;
		}
  }
}
</style>